module.exports = __webpack_public_path__ + "static/icon-supplychain-mb-3812eb7b5bf3ccc5658e5b350043c0c6.png";